module.exports = __webpack_public_path__ + "img/poe-colored-logo.8b6b1b46.svg";